var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.417 14.583h5.166v-.666H7.417zm0-3h5.166v-.666H7.417zM6 17.167q-.5 0-.833-.334-.334-.333-.334-.854V4.021q0-.521.334-.854.333-.334.854-.334h6.396l2.75 2.75v10.396q0 .521-.334.854-.333.334-.854.334zm5.833-11V3.5H6.021q-.209 0-.365.156t-.156.365v11.958q0 .209.156.365t.365.156h7.958q.209 0 .365-.156t.156-.365V6.167zM5.5 3.5v3.104V3.5v13-13z"
  })));
}

export default SvgFile;